// Global Values
var qtyMinus = document.getElementsByClassName ('js-qty__adjust--minus'),
    qtyPlus = document.getElementsByClassName ('js-qty__adjust--plus'),
    qtyValueInput = document.getElementsByClassName ('js-qty__num'), 
    currentVal, prod_vars = $(".product-variant-selection");

function valueUpdateWrapper() {
  // Disable all minus buttons on product archive to start
  $(".template-collection .js-qty__adjust--minus").addClass("js-qty__disable");  
  
  // Process the selector arrays above to add events to all elements in the Dom
  for (var i = 0; i < qtyMinus.length; i++) {
    qtyMinus[i].addEventListener('click', updateSiblingValueMinus);
  }
  for (var i = 0; i < qtyPlus.length; i++) {
    qtyPlus[i].addEventListener('click', updateSiblingValuePlus);
  }
  for (var i = 0; i < qtyValueInput.length; i++) {
    qtyValueInput[i].addEventListener('input', updateValue);
  }

  function updateValue(e) {
    currentVal = e.target.value;
    if(currentVal > 1) {
      $(this).siblings('.js-qty__adjust--minus').removeClass("js-qty__disable");
    } else {
      $(this).siblings('.js-qty__adjust--minus').addClass("js-qty__disable");
    }
  }

  function updateSiblingValueMinus(e) {
    currentVal = $(this).siblings('input').val();
    if(currentVal == 2) {
      $(this).addClass("js-qty__disable");
    }
  }

  function updateSiblingValuePlus(e) {
    currentVal = $(this).siblings('input').val();
    if(currentVal >= 1) {
      $(this).siblings('.js-qty__adjust--minus').removeClass("js-qty__disable");
    }
  }
};

function collectionLogic(delay = 1800) {
  // Use a small delay so new elements are definitely in the DOM
  setTimeout(function() {
    // Attach a click listener to all .gp-btn buttons
    jQuery(".grid-product-drawer__btn-wrap button").off("click").on("click", function() {
      const $wrapper = jQuery(this).closest(".grid-product__wrapper");
      if ($wrapper.length) {
        $wrapper.addClass("activated");
      }
    });

    // Close button
    jQuery(".grid-product-drawer-close_btn").off("click").on("click", function() {
      const $wrapper = jQuery(this).closest(".grid-product__wrapper");
      if ($wrapper.length) {
        $wrapper.removeClass("activated");
      }
    });

    // Add subscription logic to subscription button
    const $btns = jQuery(".single-variant-btn--subscribe");

    $btns.each(function() {
      const $btn = jQuery(this);        // <-- FIXED

      $btn.off("click").on("click", function(e) {
        e.preventDefault();
        const productId = this.id.replace("subscribe-btn-", "");
        const variantId = $(this).data("variant-id");
        const $select = jQuery("#subscription-frequency-" + productId);
        const sellingPlanId = $select.val();

        jQuery.ajax({
          url: "/cart/add.js",
          type: "POST",
          dataType: "json",
          contentType: "application/json",
          data: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                selling_plan: sellingPlanId
              }
            ]
          }),
          success: function(data) {
            addToCartOk();
          },
          error: function(err) {
            console.error("Error adding subscription:", err);
          }
        });
      });
    });
  }, delay);
}

collectionLogic(100);

function updateQty() {
  $('.quantity_selector').each(function () {
    const $container = $(this);
    const $qtyInput = $container.find('.qty__num');
    const $qtyMinus = $container.find('.qty__adjust--minus');
    const $qtyPlus = $container.find('.qty__adjust--plus');

    // Ensure quantity is at least 1
    function verifyQty() {
      if ($qtyInput.val() === "0") {
        $qtyInput.val(1);
      }
      return parseInt($qtyInput.val(), 10);
    }

    // Enable/disable minus button based on quantity
    function determineQty(qty) {
      if (qty <= 1) {
        $qtyMinus.attr('disabled', 'disabled').addClass('js-qty__disable');
      } else {
        $qtyMinus.removeAttr('disabled').removeClass('js-qty__disable');
      }
    }

    // Event handlers
    $qtyMinus.on('click', function () {
      let currentVal = parseInt($qtyInput.val(), 10);
      if (currentVal > 1) {
        $qtyInput.val(currentVal - 1);
        determineQty(currentVal - 1);
      }
    });

    $qtyPlus.on('click', function () {
      let currentVal = parseInt($qtyInput.val(), 10);
      $qtyInput.val(currentVal + 1);
      determineQty(currentVal + 1);
    });

    $qtyInput.on('change', function () {
      const qty = verifyQty();
      determineQty(qty);
    });

    // Initialize on page load
    determineQty(verifyQty());
  });
}

updateQty();

// Product archive ajax
"use strict";
var Ajaxinate=function(e){var t=e||{};this.settings=Object.assign({pagination:".AjaxinatePagination",method:"scroll",container:".AjaxinateLoop",offset:0,loadingText:"Loading more of your favorites...",callback:null},t),this.addScrollListeners=this.addScrollListeners.bind(this),this.addClickListener=this.addClickListener.bind(this),this.checkIfPaginationInView=this.checkIfPaginationInView.bind(this),this.stopMultipleClicks=this.stopMultipleClicks.bind(this),this.destroy=this.destroy.bind(this),this.containerElement=document.querySelector(this.settings.container),this.paginationElement=document.querySelector(this.settings.pagination),this.initialize()};Ajaxinate.prototype.initialize=function(){this.containerElement&&{click:this.addClickListener,scroll:this.addScrollListeners}[this.settings.method]()},Ajaxinate.prototype.addScrollListeners=function(){this.paginationElement&&(document.addEventListener("scroll",this.checkIfPaginationInView),window.addEventListener("resize",this.checkIfPaginationInView),window.addEventListener("orientationchange",this.checkIfPaginationInView))},Ajaxinate.prototype.addClickListener=function(){this.paginationElement&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.clickActive=!0,null!==this.nextPageLinkElement&&this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks))},Ajaxinate.prototype.stopMultipleClicks=function(e){e.preventDefault(),this.clickActive&&(this.nextPageLinkElement.innerHTML="<img src=\"//www.jigsawhealth.com/cdn/shop/t/153/assets/loading-gif.gif?v=115449\" /> Loading more of your favorites...",this.nextPageUrl=this.nextPageLinkElement.href,this.clickActive=!1,this.loadMore())},Ajaxinate.prototype.checkIfPaginationInView=function(){var e=this.paginationElement.getBoundingClientRect().top-this.settings.offset,t=this.paginationElement.getBoundingClientRect().bottom+this.settings.offset;e<=window.innerHeight&&t>=0&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.removeScrollListener(),this.nextPageLinkElement&&(this.nextPageLinkElement.innerHTML='<img style="max-width: 250px;" src="" /> Loading more of your favorites...',this.nextPageUrl=this.nextPageLinkElement.href,this.loadMore()))},Ajaxinate.prototype.loadMore=function(){this.request=new XMLHttpRequest,this.request.onreadystatechange=function(){if(4===this.request.readyState&&200===this.request.status){var e=this.request.responseXML.querySelectorAll(this.settings.container)[0],t=this.request.responseXML.querySelectorAll(this.settings.pagination)[0];this.containerElement.insertAdjacentHTML("beforeend",e.innerHTML),this.paginationElement.innerHTML=t.innerHTML,this.settings.callback&&"function"==typeof this.settings.callback&&this.settings.callback(this.request.responseXML),this.initialize(),valueUpdateWrapper()}}.bind(this),this.request.open("GET",this.nextPageUrl), collectionLogic(), this.request.responseType="document",this.request.send()},Ajaxinate.prototype.removeClickListener=function(){this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks)}, Ajaxinate.prototype.removeScrollListener=function(){document.removeEventListener("scroll",this.checkIfPaginationInView),window.removeEventListener("resize",this.checkIfPaginationInView),window.removeEventListener("orientationchange",this.checkIfPaginationInView)},Ajaxinate.prototype.destroy=function(){return{click:this.removeClickListener,scroll:this.removeScrollListener}[this.settings.method](),this};

var ajaxinate = new Ajaxinate({
  container: ".AjaxinateLoop",
  pagination: ".AjaxinatePagination",
  method: "scroll",
  callback: function() {
    collectionLogic(500) // fires after new content loads
  }
});

function headerStick() {
  let subNav = $('#subnav-header').offset(),
  $window = $(window);

  if(subNav !== undefined) {
    $window.scroll(function() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if ( $window.scrollTop() > 0) {
          $("#header").addClass("is-scrolled");
        }
        if ( $window.scrollTop() > subNav.top-3700 || $window.scrollTop() == 0) {
          $("#header").removeClass("is-scrolled");
        }
      }
      else {
        if ( $window.scrollTop() > 0) {
          $("#header").addClass("is-scrolled");
        }
        if ( $window.scrollTop() > subNav.top || $window.scrollTop() == 0) {
          $("#header").removeClass("is-scrolled");
        }
      }
    }); 
  }
}

// Contains all the Event Handlers for allowing the user to adust the quantity of the products.
function startMiniBuyBox() {
  // Increase quantity on collection page
  $('.template-collection').on('click', ".js-qty__adjust--plus", function() {
    currentVal = parseInt($(this).siblings('input').val());
    if (!isNaN(currentVal)) {
      $(this).siblings('input').val(currentVal + 1);
    }
  });

  // Decrease quantity on collection page
  $('.template-collection').on('click', ".js-qty__adjust--minus", function () {
    currentVal = parseInt($(this).siblings('input').val());
    newVal = currentVal - 1;
    
    if(newVal < 1)newVal = 1;
    if (!isNaN(currentVal)) {
      $(this).siblings('input').val(newVal);
    }
  });
}

// Contains all the Event Handlers for updating the price on the collection page.
function collectionProductListeners() {
  // Update price on collection page
  $(".template-collection").on('click', ".js-qty__adjust", function() {
    valueMultiplier = $(this).siblings('input').val();
    productPriceInitial = $(this).parent().parent().find('.grid-product__price').attr('content');
    productPrice = Number(productPriceInitial.replace(/[^0-9\.-]+/g,""));
    newSavingsPrice = valueMultiplier * productPrice;
    
    if (valueMultiplier >= 5) {
      newSavingsPrice = newSavingsPrice * 0.9 ; 
    }
    
    if (valueMultiplier >= 3 && valueMultiplier < 5) {
      newSavingsPrice = newSavingsPrice * 0.95;
    }

    $(this).parent().parent().find('.grid-product__price').text('$' + Math.round((newSavingsPrice + Number.EPSILON) * 100) / 100);
  });

  // Update price on collection page
  $(".template-collection").on('propertychange input', ".js-qty__num", function() {
    valueMultiplier = $(this).val();
    productPriceInitial = $(this).parent().parent().find('.grid-product__price').attr('content');
    productPrice = Number(productPriceInitial.replace(/[^0-9\.-]+/g,""));
    newSavingsPrice = valueMultiplier * productPrice;
    
    if (valueMultiplier >= 5) {
      newSavingsPrice = newSavingsPrice * 0.9 ; 
    }
    if (valueMultiplier >= 3 && valueMultiplier < 5) {
      newSavingsPrice = newSavingsPrice * 0.95;
    }

    $(this).parent().parent().find('.grid-product__price').text('$' + Math.round((newSavingsPrice + Number.EPSILON) * 100) / 100);
  });
}

/*** Bundle Add To Cart AJAX Call ***/
function bundleATC() {
  $('.bundle--add-to-cart').each(function(){
    $(this).click(function(e){
      e.preventDefault();

      var $formSelector = $(this).parent();

      // Arrays to store bundle data
      var bundleProductIds = [];
      var bundleProductQty = [];
      var bundleProductParents = [];

      // ----------------------------------------
      // Collect base bundle products (hidden default inputs)
      // ----------------------------------------
      $formSelector.find('.bundle-price__product').each(function() {
        const variantId = $(this).data('variant-id');
        const quantity  = $(this).data('quantity');
        const productId = $(this).data('product-id');

        bundleProductIds.push(variantId);
        bundleProductQty.push(quantity);
        bundleProductParents.push(productId);
      });

      // ----------------------------------------
      // Collect selected variants from dropdowns
      // ----------------------------------------
      $formSelector.find('.product-variant-selector').each(function() {
        const productParentId = $(this).data('product-name'); // parent product ID
        const $selected       = $(this).find('option:selected');
        const variantId       = $selected.data('variant-id');
        const quantity        = $selected.data('quantity');

        if (!variantId) return;

        // Remove any previously stored variant from this same product
        for (let i = bundleProductParents.length - 1; i >= 0; i--) {
          if (bundleProductParents[i] == productParentId) {
            bundleProductParents.splice(i, 1);
            bundleProductIds.splice(i, 1);
            bundleProductQty.splice(i, 1);
          }
        }

        // Add the newly selected variant
        bundleProductParents.push(productParentId);
        bundleProductIds.push(variantId);
        bundleProductQty.push(quantity);
      });

      // ----------------------------------------
      // Get bundle quantity multiplier
      // ----------------------------------------
      var bundleQuantitySelector = $('.bundle-product-form .js-quantity-selector').val() || 1;

      // ----------------------------------------
      // Build items array for AJAX
      // ----------------------------------------
      var dataToPass = [];
      bundleProductIds.forEach((variantId, index) => {
        var productQuantity = bundleProductQty[index];
        var addToCartQuantity = bundleQuantitySelector * productQuantity;

        // Assuming productArray constructor is defined elsewhere
        dataToPass.push(new productArray(variantId, addToCartQuantity));
      });

      // ----------------------------------------
      // Pull product ratings and review counts
      // ----------------------------------------
      var productRatingsName = [], productRatingsValue = [];
      var productReviewCountName = [], productReviewCountValue = [];

      $('.product__rating').each(function(){
        productRatingsName.push($(this).attr('name'));
        productRatingsValue.push($(this).val());
      });
      $('.product__review').each(function(){
        productReviewCountName.push($(this).attr('name'));
        productReviewCountValue.push($(this).val());
      });

      var ratingObj = {}, reviewObj = {};
      for (var i = 0; i < productRatingsName.length; i++) {
        ratingObj[productRatingsName[i]] = productRatingsValue[i];
      }
      for (var i = 0; i < productReviewCountName.length; i++) {
        reviewObj[productReviewCountName[i]] = productReviewCountValue[i];
      }

      var finalAttributes = Object.assign(ratingObj, reviewObj);

      // ----------------------------------------
      // POST bundle to cart
      // ----------------------------------------
      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        dataType: 'json',
        cors: true,
        data: {
          items: dataToPass,
          attributes: finalAttributes,
        },
        complete: function () {
          addToCartOk(); // open side cart
        }
      });
    });
  });
}

function productOneTimeATC() {
  $(".single-purchase-btn").each(function () {
    const $btn = $(this);
    const $wrapper = $btn.closest(".grid-product__wrapper");

    $btn.on("click", function(e) {
      e.preventDefault();
      let variantId;
      const quantity = $wrapper.find('.quantity_selector input').val();
      const $form = $btn.closest(".grid-product__form");
      const $selector = $form.find(".product-variant-selector");

      if($selector.length) {
        variantId = $selector.find("option:selected").attr("value");
      } else {
        variantId = $btn.data("variant-id");
      }

      $.ajax({
        url: "/cart/add.js",
        type: "POST",
        dataType: "json",
        cors: true,
        contentType: "application/json",
        data: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity
            }
          ]
        }),
        success: function (data) {
          addToCartOk();
          $wrapper.removeClass("activated");
        },
        error: function (err) {
          console.error("Error adding product:", err);
        }
      });
    });
  });
}


/*** Product Subscription Add To Cart AJAX Call ***/
function productSubscriptionATC() {
  $(".subscribe-btn").each(function () {
    const $btn = $(this);
    const $wrapper = $btn.closest(".grid-product__wrapper");
    const $dropdown = $wrapper.find(".subscription-frequency");

    if ($dropdown.length) {
      $btn.on("click", function () {
        let variantId = $btn.data("variant-id");
        const sellingPlanId = $dropdown.val();
        const quantity = $wrapper.find('.quantity_selector input').val();
        const $form = $btn.closest(".grid-product__form");
        const $selector = $form.find(".product-variant-selector");

        if($selector.length) {
          variantId = $selector.find("option:selected").attr("value");
        }

        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          dataType: "json",
          cors: true,
          contentType: "application/json",
          data: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: quantity,
                selling_plan: sellingPlanId,
              },
            ],
          }),
          success: function (data) {
            addToCartOk();
            $wrapper.removeClass("activated");
          },
          error: function (err) {
            console.error("Error adding subscription:", err);
          },
        });
      });
    }
  });
}

/*** Product Drawer Functionality & Logic ***/
function productCardDrawer() {
  // Attach a click listener to all .gp-btn buttons
  jQuery(".grid-product-drawer__btn-wrap button").on("click", function() {
    const $wrapper = jQuery(this).closest(".grid-product__wrapper");
    if ($wrapper.length) {
      $wrapper.addClass("activated");
    }
  });

  // Close button
  jQuery(".grid-product-drawer-close_btn").on("click", function() {
    const $wrapper = jQuery(this).closest(".grid-product__wrapper");
    if ($wrapper.length) {
      $wrapper.removeClass("activated");
    }
  });
}

/*** Update product price (attached per product collection card) ***/
function updateProductCardPrice() {
  $('.product-archive__list--advanced').each(function () {
    const $product = $(this);
    const $variantSelect = $product.find('.product-variant-selector');
    const $priceElements = $product.find('.grid-product__price');
    const $button = $product.find('.single-purchase-btn');

    const variantCount = $variantSelect.find('option').length;

    if (variantCount > 1) {

      function updatePriceDisplay($selectedOption) {
        const variantId = $selectedOption.data('variant-id');

        const isPreorder = $selectedOption.data('variant-preorder') === true 
          || $selectedOption.data('variant-preorder') === 'true';

        // Toggle price
        $priceElements.each(function () {
          const $price = $(this);
          $price.toggle($price.hasClass(`variant--${variantId}`));
        });

        // 👉 Handle preorder state
        if (isPreorder) {
          $button
            .text('Preorder')
            .addClass('pre-order btn--preorder');
        } else {
          $button
            // .text('One Time Purchase')
            .text('Add to Cart')
            .removeClass('pre-order btn--preorder');
        }
      }

      // Initial load
      const $initialOption = $variantSelect.find('option:selected');
      updatePriceDisplay($initialOption);

      // On change
      $variantSelect.on('change', function () {
        const $selectedOption = $(this).find('option:selected');
        updatePriceDisplay($selectedOption);
      });
    }
  });
}

/*** Updates bundle product prices (attached per product bundle collection card) ***/
function updateAllBundlePrices() {
  $('.bundle-product-form').each(function () {
    const $form = $(this);
    const $priceDisplay = $form.find('.bundle_product_price');
    const $quantityInput = $form.find('.quantity_selector .qty__num');
    const $variantSelects = $form.find('.product-variant-selector');

    function calculateBundlePrice() {
      const $bundleProducts = $form.find('input.bundle-price__product, .product-variant-selector option:selected');

      let price = $priceDisplay.attr('content') || '0';
      let valueMultiplier = parseInt($quantityInput.val()) || 1;

      price = Number(price.replace(/[^0-9\.-]+/g, ""));
      let salePriceSum = 0;

      $bundleProducts.each(function () {
        const productPrice = parseFloat($(this).attr('data-original-price')) || 0;
        salePriceSum += productPrice;
      });

      // Optional: apply quantity multiplier if needed
      // salePriceSum *= valueMultiplier;

      if (salePriceSum) {
        const sps_arr = salePriceSum.toFixed(3).split('');
        const sps_last_decimal = parseInt(sps_arr[sps_arr.length - 1]);

        const finalPrice = sps_last_decimal <= 5
          ? (Math.floor(salePriceSum * 100) / 100).toFixed(2)
          : (Math.round((salePriceSum + Number.EPSILON) * 100) / 100).toFixed(2);

        $priceDisplay.text(`$${finalPrice}`);
        $priceDisplay.attr('content', finalPrice);
      }
    }

    // Initial calculation
    calculateBundlePrice();

    // Bind change events inside this bundle
    $form.on('change', '.product-variant-selector, .quantity_selector .qty__num', calculateBundlePrice);
  });
}

/*** Reload on page load or pagination ***/
jQuery(window).on("load", function() {
  bundleATC();
  productSubscriptionATC();
  productOneTimeATC();
  productCardDrawer();
  updateProductCardPrice();
  updateAllBundlePrices()
});

function initCollectionBuyBox() {
 valueUpdateWrapper();
 startMiniBuyBox(); 
 collectionLogic();
}

initCollectionBuyBox();